import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { customReactSelectStyles } from "./medication-select";

const CommonSelect = ({
  onChange = () => {},
  isCreatable = false, // Prop to determine if the select is creatable
  options: initialOptions = [], // Prop to accept initial options
  label = "Select Option",
  labelSuffix = null,
  isRequired = false, // Prop to determine if the select is required
  value: actualValue = null,
  className = "",
  labelClassName = "",
  error = false,
  disabled = false,
  menuPlacement = "bottom", //// Options: "auto", "bottom", "top"
  removeOptional = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(initialOptions);
  const [value, setValue] = useState(actualValue || null);
  const [showError, setShowError] = useState(false);

  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue,
      };
      setIsLoading(false);
      setValue(newOption);
      onChange(newOption);
    }, 300);
  };

  const handleBlur = () => {
    if (disabled || !isRequired) {
      setShowError(false);
      return;
    }
    if (isRequired && !value) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  const SelectComponent = isCreatable ? CreatableSelect : Select; // Choose component based on isCreatable prop
  useEffect(() => {
    if (error) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [error]);

  useEffect(() => {
    // Clear stale local error when field is not required/disabled.
    if (disabled || !isRequired) {
      setShowError(false);
    }
  }, [disabled, isRequired]);
  useEffect(() => {
    if (actualValue?.value) {
      setValue(actualValue);
    } else {
      setValue(null);
    }
  }, [actualValue]);

  useEffect(() => {
    setOptions(initialOptions);
  }, [initialOptions]);

  const customOptionLabel = (option) => (
    <div>
      {option.label}
      {option.subLabel && (
        <>
          <br />
          <p className="italic">{option.subLabel}</p>
        </>
      )}
    </div>
  );

  return (
    <div className={`${className || "w-full col-span-8"} `}>
      <div
        className={`relative rounded-[4px] border-[1px] 
            ${disabled ? 'pointer-events-none opacity-70': ''} ${!disabled && isRequired && value === null ? "bg-blue-100" : "bg-white"} ${
          showError ? "border-red-200" : "border-gray-100"
        } px-3 py-3 focus-within:border-REELTeal focus-within:border-[2px]`}
      >
        <div>
          <span className={`flex items-center gap-1 mb-1 text-gray-900 ${labelClassName || "text-body-xs"}`}>
            {label}{labelSuffix ? <>{labelSuffix}</> : null} {isRequired && <span className="">*</span>}{" "}
            {!isRequired && !removeOptional && <span> (Optional)</span>}
          </span>
          <SelectComponent
            isClearable
            styles={customReactSelectStyles(isRequired, value)}
            isDisabled={isLoading || disabled}
            isLoading={isLoading}
            onChange={(newValue) => {
              setValue(newValue);
              setShowError(isRequired && !newValue);
              onChange(newValue);
            }}
            onCreateOption={isCreatable ? handleCreate : undefined} // Only pass handleCreate if creatable
            onBlur={handleBlur}
            options={options}
            value={value}
            placeholder={`Select ${label}`}
            className="col-span-4"
            menuPlacement={menuPlacement}
            formatOptionLabel={customOptionLabel} // formats both dropdown and selected value
          />
        </div>
      </div>
      {showError && (
        <span className="block mt-1 text-red-200 text-body-xs">
          {label} is required
        </span>
      )}
    </div>
  );
};

export default CommonSelect;
